import { Box, Button, Grid, Typography } from '@mui/material'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { Layout } from 'shared/utils'
import { TableComponent } from 'shared/components/Table.component';
import { Dispatch, Spinner } from 'shared';
import { useWidth } from 'shared/hooks/HookDetailedConsultation/useWidth';
import { useUsersTfe } from './hook/useUsersTfe';
import styles from '../user-provider-management/styles/userManagement.module.scss'
import { GroupAdd } from '@mui/icons-material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const UsersTfe = () => {

    const { showForm,
        toogleShowForm,
        handleChange,
        handleSubmit,
        getValue,
        AddUsers,
        getDataUsers,
        isLoading,
        loading,
        dataFields,
        columns,
        valuesResultsPages } = useUsersTfe();

    const { width } = useWidth();

    const dispatch = useDispatch<Dispatch>();

    useEffect(() => {
        dispatch.electronicDocuments.cleanState();
        getDataUsers();
      }, [])

    return (
        <Layout>
            <Box display={'flex'} justifyContent={'space-between'} marginTop={'.3rem'}>
                <Typography className='titleMainLayout'>Gestion de Usuarios</Typography>
                <Box display={'flex'} gap={1}>
                    <Button 
                        className={styles.buttonsActions}
                        onClick={() => AddUsers()}
                        endIcon={<GroupAdd/>}
                        variant='contained' 
                        data-testid='update-excel'
                    >
                        Agregar usuarios
                    </Button>
                    <Button 
                        className={styles.buttonsActions}
                        onClick={toogleShowForm}
                        endIcon={showForm ? <FilterAltOffIcon/> : <FilterAltIcon/>}
                        variant='contained' 
                        data-testid='btn-filters-users'
                    >
                        Filtrar
                    </Button>
                </Box>
            </Box>
            {
                showForm && (
                <form className={`${styles.formReadDocuments} form-documents`} noValidate onSubmit={handleSubmit} data-testid='form-read-documents'>
                    <Grid container direction={"row"} className={styles.containerReadDocuments}>
                    {
                        dataFields.map((field,i)=> (
                            <Grid item xs={12} md={6} lg={5} className={ styles.containerGridItem } key={i}>
                                <label htmlFor={field.id}>
                                    {field.label}
                                </label>
                                <input 
                                    type='text'
                                    name={field.name}
                                    placeholder={field.placeholder}
                                    id={field.id}
                                    data-testid={field.testId}
                                    value={ getValue(field.name) }
                                    onChange={handleChange}
                                />
                            </Grid>
                            
                        ))
                    }
                        <Grid item display={"flex"} alignItems={'center'} justifyContent={'center'} xs={12} lg={2}>
                            <Button type='submit' variant='contained' color='secondary' className={styles.buttonSubmit} data-testid="btn-submit">
                                Consultar
                            </Button>
                            <Button variant='contained' color='secondary' className={styles.buttonSubmit} data-testid="btn-submit" onClick={getDataUsers}>
                                Limpiar
                            </Button>
                        </Grid>
                    </Grid>

                </form>
                )
            }
            <Box 
                paddingTop={'.5rem'} 
                height={showForm ? '72%' : '89%'}
            >
                <TableComponent 
                    columns={columns}
                    title=''
                    valuesResultsPages={valuesResultsPages}
                    classTotalElemnt={width < 500 ? '' : 'classTotalElemnt'}
                    showBtnCollapse={false}
                    hiddenHeaderSearch={true}
                    isSearch={false}
                />
            </Box>
            {( loading || isLoading ) && <Spinner />}
        </Layout>
    )
}
